import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=0a3cfbb9&scoped=true&"
import script from "./Pos.vue?vue&type=script&lang=js&"
export * from "./Pos.vue?vue&type=script&lang=js&"
import style0 from "./Pos.vue?vue&type=style&index=0&id=0a3cfbb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3cfbb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3cfbb9')) {
      api.createRecord('0a3cfbb9', component.options)
    } else {
      api.reload('0a3cfbb9', component.options)
    }
    module.hot.accept("./Pos.vue?vue&type=template&id=0a3cfbb9&scoped=true&", function () {
      api.rerender('0a3cfbb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Pos.vue"
export default component.exports